export const convertDaysToSeconds = (value: string):number => {
  const days = parseInt(value, 10);
  return isNaN(days) ? 0 : days * 86400;
};

export const convertSecondsToDays = (value: number):string => {
  return Math.floor(value / 86400).toString();
};
